var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// partial application of valdiateAndSetField. Given a invalidValueLogger function, returns
// a validateAndSetFieldValue function with that invalidValueLogger.
export function getValidateAndSetFieldValueWithInvalidValueLogger(invalidValueLogger) {
    var f = function (dropdown, value, options) {
        if (options === void 0) { options = {}; }
        return validateAndSetFieldValue(dropdown, value, __assign({ invalidValueLogger: invalidValueLogger }, options));
    };
    return f;
}
// given a dropdown, a value, and a field, sets the value in the drop down.
// optionally logs information if the value is not in the dropdown and a invalidValueLogger
// is provided in options.
export var validateAndSetFieldValue = function (dropdown, value, _a) {
    var _b = _a === void 0 ? {} : _a, invalidValueLogger = _b.invalidValueLogger, logValues = _b.logValues;
    if (dropdown
        .getOptions()
        .some(function (option) { return option[1] === value || option[1] === "\"".concat(value, "\""); })) {
        dropdown.setValue(value);
    }
    else {
        invalidValueLogger === null || invalidValueLogger === void 0 ? void 0 : invalidValueLogger({
            message: 'Invalid generated value',
            value: value,
            logValues: logValues,
        });
    }
};
